<div class="list-container">
  <h1 class="text-2xl font-bold mb-4">{{ 'USER_GROUPS.LIST.TITLE' | translate }}</h1>

  @if (error) {
    <app-alert [type]="'danger'">{{ error }}</app-alert>
  }

  <app-button color="primary" [rounded]="'full'" [routerLink]="['/users/groups/create']">
    {{ 'USER_GROUPS.LIST.CREATE' | translate }}
  </app-button>

  @if (paginationState().loading) {
    <div class="mb-4">
      <app-loading size="large" color="primary" />
    </div>
  }

  @if (!paginationState().loading && groups.length > 0) {
    <div class="overflow-x-auto mt-2">
      <table class="table-auto w-full border-collapse border border-slate-400">
        <thead>
        <tr class="bg-neutral-100 dark:bg-neutral-700">
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.LIST.ID' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.LIST.NAME' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.LIST.DESCRIPTION' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2">{{ 'USER_GROUPS.LIST.USER_COUNT' | translate }}</th>
          <th class="border border-neutral-300 dark:border-neutral-600 p-2"></th>
        </tr>
        </thead>
        <tbody>
        @for (group of groups; track group.id; let even = $even) {
          <tr [ngClass]="even ? 'bg-neutral-50 dark:bg-neutral-800' : 'bg-white dark:bg-neutral-900'">
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ group.id }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ group.name }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ group.description }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">{{ group.userCount }}</td>
            <td class="border border-neutral-300 dark:border-neutral-600 p-2">
              <a class="flex items-center justify-center underline" [routerLink]="['/users/groups/edit', group.id]">
                <i [innerHTML]="'edit' | feather: { width: 16, height: 16 }"></i>
              </a>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="8">{{ 'PAGINATION.NO_ITEMS' | translate }}</td>
          </tr>
        }
        </tbody>
      </table>

      <app-pagination [paginationState]="paginationState()" [onPaginationChange]="onPageChange"></app-pagination>
    </div>
  }
</div>
